import type { ConnectionEditState } from "../../viewmodels/board/connections/Connections.types";

export const getSourceSettingsEditorRefreshKey = (
  editingConnection: ConnectionEditState,
): string =>
  [
    editingConnection.id,
    editingConnection.sourceTypeId,
    editingConnection.profileId,
    editingConnection.profileName,
    editingConnection.isAuthorised ? "1" : "0",
  ].join("|");
